import { styled } from "styled-components";

const StyledContainer = styled.div`
  width: 100%;

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  code,
  pre {
    background-color: ${({ theme }): string => theme.palette.gray[100]};
    border-radius: 4px;
    padding: 2px 4px;
  }
`;

export { StyledContainer };
